// extracted by mini-css-extract-plugin
export default {"globe":"icons_globe__20s95","id":"icons_id__WwHZ3"};